module.exports =
  getQueryStringByName: (name) ->
    # Gets the value of a query string parameter.
    # Based on http://stackoverflow.com/a/901144/694086
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]")
    regex = new RegExp("[\\?&]" + name + "=([^&#]*)")
    results = regex.exec location.search
    return null unless results?
    decodeURIComponent results[1].replace(/\+/g, ' ')
